const TOKEN_KEY = 'xfqj_school_token_key';
const TOKEN_EXPIRED = 'xfqj_school_token_expired';
// token有效期（毫秒），两个小时
const TOKEN_ACTIVE = 864000000;

export const getToken = () => {
  const expired = window.localStorage.getItem(TOKEN_EXPIRED);
  if (expired) {
    try {
      const expiredNum = Number.parseInt(expired);
      if (expiredNum > new Date().getTime()) {
        return window.localStorage.getItem(TOKEN_KEY);
      }
    } catch (e) {
    }
  }

  return null;

}

export const setToken = (token) => {
  window.localStorage.setItem(TOKEN_EXPIRED, `${new Date().getTime() + TOKEN_ACTIVE}`);
  window.localStorage.setItem(TOKEN_KEY, token);
}
